var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humidity_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1227 4.07382L8.00001 1L5.87728 4.07382C4.80228 5.62824 3 8.49618 3 10.2297C3 12.8588 5.24318 15 8.00001 15C10.7568 15 13 12.8588 13 10.2297C13 8.49618 11.1977 5.62824 10.1227 4.07382ZM7.03182 4.72853L8.00001 3.32853L8.96819 4.72853C9.13935 4.97173 9.30603 5.21741 9.46816 5.46548C10.2033 6.5902 9.34365 8 8.00001 8C6.65636 8 5.79673 6.5902 6.53185 5.46548C6.69399 5.21741 6.86067 4.97173 7.03182 4.72853Z",
    fill: "#12192B",
    fillOpacity: 0.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/Humidity.1f3a1118f52e3ca3bf472eb7eda2653e.svg";
export { ForwardRef as ReactComponent };